module.exports = __webpack_public_path__ + "static/apps-94ca9e6c1e074c31d623961ccc5d7844.png";